
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M14.445 11.885a16.632 16.632 0 1 1 4.258 28.43l-1.418 3.566a20.47 20.47 0 1 0-10.611-9.606l-.002.005a20.5 20.5 0 0 0 4.307 5.633q.495-1.088 1.194-2.678 1.118-2.649 1.895-4.155.582-1.119 1.094-1.883a10 10 0 0 1 1.239-1.494 4.8 4.8 0 0 1 1.676-1.093q.948-.365 2.114-.365h3.386l-4.445 4.445 3.178 3.178 10.733-10.733L22.31 14.4l-3.178 3.178 4.445 4.445H20.19q-1.653 0-3.11.401-1.457.402-2.587 1.02-1.131.62-2.186 1.664a20 20 0 0 0-1.797 2.016q-.742.972-1.555 2.43l-.04.071a16.63 16.63 0 0 1 5.53-17.74"}}),_c('path',{staticClass:"i-outline",attrs:{"stroke":"#234652","d":"M13.065 10.272A16.632 16.632 0 1 1 17.323 38.7l-1.419 3.566a20.47 20.47 0 1 0-10.61-9.606l-.003.005a20.5 20.5 0 0 0 4.307 5.633q.495-1.088 1.194-2.678 1.119-2.648 1.895-4.155.583-1.118 1.094-1.883a10 10 0 0 1 1.24-1.493 4.8 4.8 0 0 1 1.675-1.094q.949-.365 2.114-.365h3.386l-4.445 4.445 3.178 3.178 10.733-10.733L20.93 12.788l-3.178 3.177 4.445 4.445H18.81q-1.652 0-3.11.402-1.455.4-2.587 1.02-1.13.618-2.186 1.664a20 20 0 0 0-1.797 2.016q-.741.97-1.555 2.43l-.04.07a16.63 16.63 0 0 1 5.53-17.74Z"}})])
          )
        }
      }
    